import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Modal, Pagination, Form } from 'react-bootstrap';

import Loading from '../../../components/Loading/Loading';
import throttle from '../../../utils/throttle';
import pagination from '../../../utils/pagination';

import { linkAccToPartner } from '../AccountsActions';
import { getPartners } from '../../Partners/PartnersActions';

import Close from '../../../assets/images/close.svg';
import Link from '../../../assets/images/link.svg';

import '../../../assets/styles/_table.scss';
import './transfer-modal.scss';

class LinkAccountToPartner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: props.visible,
      search: '',
      isLoading: true,
      results: [],
      page: 0,
      total: 0,
      selectedPartner: '',
      sort: 'name',
      sortDir: 'asc',
    };

    this.getPartnersThrottled = throttle(this.getPartners, 500, this);
  }

  getPartners = () => {
    const { platform, filter, sort, search, page } = this.state;

    this.setState(
      {
        isLoading: true,
      },
      () => {
        this.props
          .getPartners({
            platform,
            filter,
            sort,
            search,
            page,
            pageSize: this.props.pageSize,
          })
          .then((res) => {
            this.setState({
              isLoading: false,
              results: _.filter(res.results, (r) => {
                return r._id !== this.props.accountId;
              }),
              page: res.page,
              total: res.total,
            });
          });
      }
    );
  };

  goto = (page = 1) => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getPartners);
  };

  resetState = () => {
    this.setState({
      isOpened: false,
      isLoading: true,
      results: [],
      page: 0,
      total: 0,
      selectedPartner: '',
    });
  };

  toggleSort = () => {
    const sortDir = this.state.sortDir === 'asc' ? 'desc' : 'asc';
    const sort = sortDir === 'asc' ? 'name' : '-name';
    this.setState({ sort, sortDir, page: 1 }, this.getPartners);
  };

  handleChange = (ev) => {
    this.setState({ search: ev.target.value, page: 1 });
    this.getPartnersThrottled();
  };

  onButtonClick = () => {
    if (!this.state.isOpened) {
      this.setState({ isOpened: true });
      this.getPartners();
    }
  };

  onClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    this.resetState();

    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  onConfirm = (event) => {
    event.stopPropagation();

    this.props
      .linkAccToPartner(this.state.selectedPartner)
      .then(() => {
        this.resetState();
        if (typeof this.props.onClose === 'function') {
          this.props.onClose(true);
        }
      })
      .catch(() => {});
  };

  renderPagination = () => {
    const pages = pagination(this.state.total, this.state.page, this.props.pageSize, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }
    return (
      <Pagination>
        {pages.currentPage > 1 && <Pagination.First onClick={() => this.goto(1)} />}
        {pages.currentPage > 1 && <Pagination.Prev onClick={() => this.goto(pages.currentPage - 1)} />}
        {pages.pages.map((p, i) => {
          return (
            <Pagination.Item key={i} active={p === pages.currentPage} onClick={() => this.goto(p)}>
              {p}
            </Pagination.Item>
          );
        })}
        {pages.currentPage < pages.totalPages && <Pagination.Next onClick={() => this.goto(pages.currentPage + 1)} />}
        {pages.currentPage < pages.totalPages && <Pagination.Last onClick={() => this.goto(pages.totalPages)} />}
      </Pagination>
    );
  };

  renderRow = (data, i) => {
    return (
      <tr
        key={i}
        onClick={() => this.setState({ selectedPartner: data.userId })}
        className={`selectable row-item ${ this.state.selectedPartner === data.userId ? 'selected' : '' }`}
      >
        {/* Col 1 */}
        <td>
          <span>{data.name}</span>
        </td>
        {/* Col 2 */}
        <td>
          <span>{data.email}</span>
        </td>
        {/* Col 3 */}
        <td>
          <span>{_.upperFirst(data.refId)}</span>
        </td>
      </tr>
    );
  };

  render() {
    const { isLoading, results, total, sortDir } = this.state;

    const modal = (
      <Modal
        show={this.state.isOpened}
        onHide={this.onClose}
        className='transfer_modal'
        keyboard={this.props.keyboard}
        backdrop={this.props.backdrop}
        enforceFocus={this.props.enforceFocus}
      >
        <Modal.Header>
          <Modal.Title>Link Account to Partner</Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className='table-content'>
              <div className='table-filter'>
                <div className='filter-content' id="filter-content"></div>
                <Form.Group controlId="Search" className="search-form">
                  <Form.Control
                    type="text"
                    name="search"
                    placeholder="Search"
                    onChange={this.handleChange}
                    value={this.state.search}
                  />
                </Form.Group>
              </div>

              {isLoading && (
                <div className='table-loading'>
                  <Loading />
                </div>
              )}
              {!isLoading && total === 0 && (
                <div className='no_data'>
                  <p> No data available </p>
                </div>
              )}

              <div className='table'>
                <table>
                  <thead>
                    <tr>
                      <th onClick={this.toggleSort} className='sortable'>
                        Name <span className='sort-icon'>{sortDir === 'asc' ? '↓' : '↑'}</span>
                      </th>
                      <th>Email</th>
                      <th>Referal No</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isLoading &&
                      results &&
                      _.map(_.take(results, this.props.pageSize), (data, i) => this.renderRow(data, i))}
                  </tbody>
                </table>
              </div>


            </div>
            {total > 0 && this.renderPagination()}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={this.onConfirm} disabled={!this.state.selectedPartner}>
            <img src={Link} alt='link' /> Link
           </Button>
          <Button variant="secondary" onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          onClick: this.onButtonClick,
          style: this.props.style,
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }
    return content;
  }
}

LinkAccountToPartner.propTypes = {
  accountId: PropTypes.string.isRequired,
  buttonText: PropTypes.node,
  keyboard: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  enforceFocus: PropTypes.bool,
  onClose: PropTypes.func,
  visible: PropTypes.bool,
};

LinkAccountToPartner.defaultProps = {
  pageSize: 10,
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    getPartners: (opt) => dispatch(getPartners(opt, true)),
    linkAccToPartner: (partnerId) => dispatch(linkAccToPartner(props.accountId, partnerId)),
  };
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkAccountToPartner);
